import { toastr } from 'react-redux-toastr';

import types from './constant';
import selectorStarted from '@Components/started/selector';
import selectorLogin from '@Components/login/selector';
import * as actionLogin from '@Components/login/signIn/action';
import { setTabBilling } from '../billing/Overview/config/action';
import * as actionConfig from '@Actions/config';
import * as util from '@Util';
import systemConfigs from '@Constants/systemConfigs';
import * as routes from '@Constants/router';
import { getUserPdfSettings } from '../pdfGenerator/action';

// O shell do MVF pré-aquece o iframe antes de saber o destino e grava
// legacyNext apontando para o próprio bootstrap (/started). Redirecionar para
// lá deixa o iframe parado em /started, onde o App não emite USECORE_READY, e
// o shell fica no skeleton esperando o sinal para enviar a navegação real.
// Nesse caso o destino passa a ser o app padrão do workspace, que emite o
// READY e deixa o iframe apto a receber o USECORE_NAVIGATE.
const resolveMvfLegacyNext = (legacyNext) => {
  if (typeof legacyNext !== 'string') return null;

  const suffixIndex = legacyNext.search(/[?#]/);
  const path = suffixIndex < 0 ? legacyNext : legacyNext.slice(0, suffixIndex);
  const suffix = suffixIndex < 0 ? '' : legacyNext.slice(suffixIndex);
  const routePath = path.replace(/^\/legacy(?=\/|$)/, '').replace(/\/+$/, '');
  const isBootstrapRoute = routePath === '' || routePath === `/${routes.ROUTE_STARTED}`;

  return isBootstrapRoute ? `/${routes.ROUTE_BASIC}${suffix}` : legacyNext;
};

export const setIsFirstLoading = (data) => ({
  type: types.STARTED_OVERVIEW_IS_FIRST_LOADING,
  payload: data,
});

export const getUserDashboardFetchRequet = () => ({
  type: types.STARTED_OVERVIEW_GET_USER_DASHBOARD_FETCH_REQUEST,
});
export const getUserDashboardFetchSuccess = (data) => ({
  type: types.STARTED_OVERVIEW_GET_USER_DASHBOARD_FETCH_SUCCESS,
  payload: data,
});
export const getUserDashboardFetchError = (data) => ({
  type: types.STARTED_OVERVIEW_GET_USER_DASHBOARD_FETCH_ERROR,
  payload: data,
});

export const createAccountFetchRequet = () => ({
  type: types.STARTED_OVERVIEW_CREATE_ACCOUNT_FETCH_REQUEST,
});
export const createAccountFetchSuccess = (data) => ({
  type: types.STARTED_OVERVIEW_CREATE_ACCOUNT_FETCH_SUCCESS,
  payload: data,
});
export const createAccountFetchError = (data) => ({
  type: types.STARTED_OVERVIEW_CREATE_ACCOUNT_FETCH_ERROR,
  payload: data,
});

export const selectedBusinessFetchRequet = () => ({
  type: types.STARTED_OVERVIEW_SET_SELECTED_BUSINESS_FETCH_REQUEST,
});
export const selectedBusinessFetchSuccess = (data) => ({
  type: types.STARTED_OVERVIEW_SET_SELECTED_BUSINESS_FETCH_SUCCESS,
  payload: data,
});
export const selectedBusinessFetchError = (data) => ({
  type: types.STARTED_OVERVIEW_SET_SELECTED_BUSINESS_FETCH_ERROR,
  payload: data,
});

export const openedModal = () => ({
  type: types.STARTED_OVERVIEW_MODAL_OPENED,
});
export const closedModal = () => ({
  type: types.STARTED_OVERVIEW_MODAL_CLOSED,
});

export const setSelectedBusiness = (data) => ({
  type: types.STARTED_OVERVIEW_SET_SELECTED_BUSINESS,
  payload: data,
});

export const getUserDashboard = () => async (dispatch, getState, api) => {
  const state = getState();
  const userId = selectorLogin.getAuthUserId(state);
  const header = selectorLogin.getHeaderConfig(state);
  const auth = JSON.parse(util.getCookie('auth') || '{}');
  // O mvfContext do cookie sobrevive ao fluxo embedded (maxAge de dias);
  // só vale quando este load está de fato dentro do MVF, senão o acesso
  // direto ao /legacy herda o deep-link do iframe.
  const mvfContext = (util.isMvfEmbeddedWindow() && auth.mvfContext) || {};
  const desiredUsecoreWorkspaceId = Number(mvfContext.usecoreWorkspaceId || 0);
  const legacyNext = resolveMvfLegacyNext(mvfContext.legacyNext);

  dispatch(getUserDashboardFetchRequet());

  const currentWorkspaceId = Number(auth.business && auth.business.workspaceId ? auth.business.workspaceId : 0);
  const currentAccountId = Number(
    auth.business && auth.business.accountId
      ? auth.business.accountId
      : mvfContext.usecoreAccountId || 0
  );

  try {
    // No deep-link do MVF já sabemos, antes do dashboard responder, se o
    // selectedBusiness vai rodar (workspace divergente ou sem accountId) e
    // qual workspace ele vai usar — então a busca de apps desse workspace é
    // disparada em paralelo com o dashboard em vez de esperar em série.
    const willAutoSelectMvfWorkspace =
      desiredUsecoreWorkspaceId > 0 &&
      (currentWorkspaceId !== desiredUsecoreWorkspaceId || currentAccountId <= 0);
    const preloadedUserApps = willAutoSelectMvfWorkspace
      ? api.workspace
          .getUserWorkspaceApps(desiredUsecoreWorkspaceId)
          .catch(() => null)
      : null;

    let response = await api.user.getUserDashboard({ userId });
    const listAccount = response.data.accounts;
    const listWorkspace = response.data.workspaces;
    const mvfWorkspace = desiredUsecoreWorkspaceId > 0
      ? listWorkspace.find(workspace => Number(workspace.workspaceId) === desiredUsecoreWorkspaceId)
      : null;

    if (mvfWorkspace && currentWorkspaceId === desiredUsecoreWorkspaceId && currentAccountId > 0 && legacyNext) {
      dispatch(actionConfig.routeReplace(legacyNext));
      return;
    }

    if (mvfWorkspace && (currentWorkspaceId !== desiredUsecoreWorkspaceId || currentAccountId <= 0)) {
      dispatch(
        selectedBusiness({
          ...mvfWorkspace,
          id: mvfWorkspace.workspaceId,
          name: mvfWorkspace.workspace,
          url: 'app',
          redirectUrl: legacyNext || undefined,
          autoRedirect: true,
          preloadedUserApps,
        })
      );
      return;
    }

    // if (!listAccount.length && !listWorkspace.length) {
    //   await api.apiPayment.payment.createAccountPurchaseRequest({ header });
    //   dispatch(actionConfig.routeRedirect('/purchase'));
    // } else {
    if (!listAccount.length && listWorkspace.length === 1) {
      const workspace = listWorkspace[0];
      dispatch(
        selectedBusiness({
          ...workspace,
          id: workspace.workspaceId,
          name: workspace.workspace,
          url: 'app',
          autoRedirect: true,
        })
      );
    } else {
      dispatch(
        getUserDashboardFetchSuccess({
          listWorkspace,
          listAccount,
        })
      );
    }
    // }
  } catch (error) {
    dispatch(util.managerExceptionURI(error, getUserDashboardFetchError));
    if (error && error.status === 401)
      dispatch(actionConfig.routeRedirect('/'));
    // window.location = systemConfigs.AUTH_DOMAIN;
  }
};

export const createAccount = ({ enableIntegration, name, key }) => async (
  dispatch,
  getState,
  api
) => {
  const state = getState();
  const userId = selectorLogin.getAuthUserId(state);

  dispatch(createAccountFetchRequet());

  try {
    !enableIntegration
      ? await api.account.createAccount({ name, userId })
      : await api.account.createIntegration({ key });

    toastr.success('Sucesso', 'Salvo com sucesso!');

    dispatch([
      createAccountFetchSuccess(),
      actionConfig.resetForms('FormModalStartedCreateBusiness'),
      getUserDashboard(),
    ]);
  } catch (error) {
    dispatch(util.managerExceptionURI(error, createAccountFetchError));
    if (error && error.status === 401)
      dispatch(actionConfig.routeRedirect('/'));
    // window.location = systemConfigs.AUTH_DOMAIN;
  }
};

export const selectedBusiness = (payload) => async (dispatch, getState, api) => {
  // preloadedUserApps (Promise) e autoRedirect são metadados do fluxo de
  // bootstrap: não podem ir para o cookie `auth.business` (data é
  // serializado abaixo), então saem do objeto logo aqui.
  const { preloadedUserApps, autoRedirect, ...data } = payload;
  const redirectAction = autoRedirect
    ? actionConfig.routeReplace
    : actionConfig.routeRedirect;
  const state = getState();
  const _business = selectorStarted.getBusiness(state);
  const header = selectorLogin.getHeaderConfig(state);
  dispatch(selectedBusinessFetchRequet());
  const auth = JSON.parse(util.getCookie('auth') || '{}');

  if (!Object.keys(auth).length) {
    dispatch(actionConfig.routeRedirect('/'));
    // window.location = systemConfigs.AUTH_DOMAIN;
    return;
  }
  const funcKeys = [...Array(14).keys()].filter((i) => i != 0);
  let permissionsBilling = {};
  funcKeys.forEach((i) => {
    permissionsBilling = { ...permissionsBilling, [i]: false };
  });
  if (data.url === 'billing') {
    auth.business = { ...data };
    auth.permissions = {
      functionalitiesIds: [12, 13],
      account: {
        ...permissionsBilling,
        12: true,
        13: true,
      },
    };
    util.setCookie('auth', JSON.stringify(auth), systemConfigs.ROOT_DOMAIN);
    const lang = navigator.language || navigator.userLanguage;
    dispatch([
      actionLogin.setAuthPermissionRequest(),
      actionLogin.setAuth({ ...auth, lang }),
      actionLogin.setAuthPermission({ permissions: auth.permissions }),
      selectedBusinessFetchSuccess(data),
      setTabBilling('tab:invoice'),
      actionConfig.routeRedirect('/manager/' + data.url),
    ]);
    return;
  }
  try {
    if (data.url === 'app') {
      // Apenas getWorkspaceProfileById depende da resposta de apps; as demais
      // chamadas usam ids já conhecidos e rodam em paralelo, em vez da cadeia
      // serial apps -> (profile, funcionalidades, grupo) -> pdfSettings que
      // segurava o redirect do bootstrap.
      dispatch([getUserPdfSettings(data.workspaceId)]);

      const userAppsPromise =
        preloadedUserApps || api.workspace.getUserWorkspaceApps(data.id);
      const functionalitiesPromise = api.permission.getWorkspaceFunctionalities(data.accountId);
      const groupPermissionPromise = api.apiAccount.account.getGroupPermissionByAccountId({ accountId: data.accountId, header });
      // Evita unhandled rejection caso a chamada de apps falhe antes do
      // Promise.all abaixo observar estas promises.
      functionalitiesPromise.catch(() => {});
      groupPermissionPromise.catch(() => {});

      let resGetUser = await userAppsPromise;
      if (!resGetUser) {
        // O preload do getUserDashboard falhou (resolve null): tenta de novo
        // aqui para o erro real cair no catch deste fluxo.
        resGetUser = await api.workspace.getUserWorkspaceApps(data.id);
      }
      resGetUser = resGetUser.data;

      data.userApps = resGetUser.apps;
      data.workspaceProfileId = resGetUser.workspaceProfileId;

      const [workspaceProfile, workspaceFunctionalities, groupPermissionResponse] = await Promise.all([
        api.permission.getWorkspaceProfileById(resGetUser.workspaceProfileId),
        functionalitiesPromise,
        groupPermissionPromise,
      ]);

      const { appIds, functionalitiesIds, appFunctionalitiesIds, isAgentHubOnly } = workspaceProfile || {};
      const { apps = [] } = workspaceFunctionalities || {};
      const listAccount = groupPermissionResponse?.data || [];
      auth.groupPermission = listAccount;


      if (isAgentHubOnly) {
        auth.permissions = {
          workspace: { 11: true },
          functionalitiesIds: [11],
          isAgentHubOnly: true
        };
        auth.business = { ...data, isAgentHubOnly: true };
        util.setCookie('auth', JSON.stringify(auth), systemConfigs.ROOT_DOMAIN);

        const lang = navigator.language || navigator.userLanguage;

        dispatch([
          actionLogin.setAuthPermissionRequest(),
          actionLogin.setAuth({ ...auth, lang }),
          actionLogin.setAuthPermission({ permissions: auth.permissions }),
          selectedBusinessFetchSuccess(data),
          redirectAction(`/app/aiAgents`),
        ]);
        return;
      }

      const permissions = {
        appsIds: {},
        workspace: {},
      };

      functionalitiesIds.forEach(
        (item) => (permissions.workspace[item] = true)
      );

      for (let appId of appIds) {
        const { functionalities = [] } =
          apps.filter((item) => item.appId === appId)[0] || {};

        for (let functionality of functionalities) {
          const enable =
            !!appFunctionalitiesIds.filter(
              (ids) => ids === functionality.functionalityId
            )[0] || false;

          permissions.appsIds[appId] = {
            ...permissions.appsIds[appId],
            [functionality.functionalityId]: enable,
          };
        }
      }

      auth.permissions = {
        ...permissions,
        appIds,
        functionalitiesIds,
        appFunctionalitiesIds,
      };
    }


    auth.business = { ...data };
    util.setCookie('auth', JSON.stringify(auth), systemConfigs.ROOT_DOMAIN);

    const lang = navigator.language || navigator.userLanguage;

    dispatch([
      actionLogin.setAuthPermissionRequest(),
      actionLogin.setAuth({ ...auth, lang }),
      actionLogin.setAuthPermission({ permissions: auth.permissions }),
      selectedBusinessFetchSuccess(data),
      redirectAction(data.redirectUrl || data.url),
    ]);
  } catch (error) {
    dispatch(util.managerExceptionURI(error, selectedBusinessFetchError));
    if (error && error.status === 401)
      dispatch(actionConfig.routeRedirect('/'));
    // window.location = systemConfigs.AUTH_DOMAIN;
  }
};

export const updateBusiness = (props) => (dispatch, getState, api) => {
  const auth = JSON.parse(util.getCookie('auth') || '{}');

  if (!Object.keys(auth).length) {
    dispatch(actionConfig.routeRedirect('/'));
    // window.location = systemConfigs.AUTH_DOMAIN;
    return;
  }

  if (auth.hasOwnProperty('business')) {
    auth.business.name = props.name;
  }

  util.setCookie('auth', JSON.stringify(auth), systemConfigs.ROOT_DOMAIN);

  dispatch(setSelectedBusiness(props));
};
